var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellMobile = function SvgBellMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.362 2.25 3.475 4.377.163.204v10.862l3.107 7.782H3.893L7 17.693V6.831l.163-.204 3.475-4.377zM8.5 7.354V17.98l-.054.134-2.34 5.86h19.788l-2.34-5.86-.054-.134V7.354L20.638 3.75h-9.276z",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 28.25v1.5h-6v-1.5z"
  })));
};
export { SvgBellMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41IiBkPSJNMjEuMzYyMyAyLjI1TDI0LjgzNjkgNi42MjY5NUwyNSA2LjgzMTA1VjE3LjY5MzRMMjguMTA3NCAyNS40NzQ2SDMuODkyNThMNyAxNy42OTM0VjYuODMxMDVMNy4xNjMwOSA2LjYyNjk1TDEwLjYzNzcgMi4yNUgyMS4zNjIzWk04LjUgNy4zNTM1MlYxNy45ODE0TDguNDQ2MjkgMTguMTE1Mkw2LjEwNjQ1IDIzLjk3NDZIMjUuODkzNkwyMy41NTM3IDE4LjExNTJMMjMuNSAxNy45ODE0VjcuMzUzNTJMMjAuNjM3NyAzLjc1SDExLjM2MjNMOC41IDcuMzUzNTJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTkgMjguMjVWMjkuNzVIMTNWMjguMjVIMTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";